import { RE_SELLER } from '../constant/actionTypes';

export default (state, action) => {
  switch (action.type) {
    case RE_SELLER.GET.INITIATE:
      return {
        isFetching: true,
        data: action.payload,
      };
    case RE_SELLER.GET.SUCCESS:
      return {
        isFetching: false,
        data: action.payload,
      };
    case RE_SELLER.GET.ERROR:
      return {
        isFetching: false,
        data: action.payload,
      };
    default:
      return (typeof state === 'undefined') ? {} : state;
  }
};
